import React, { useEffect } from 'react';
import { FormattedText, formatText } from 'core/i18n';
import MessagesScreen from 'components/messagesScreen/messagesScreen';
import { VIDEO_CALL, VIDEO_SELFIE } from 'constants/identityMethod';
import { recordEventStepSuccess } from 'utilities/uTagging';
import { IDENTITY_VIDEOS_RECORD_TAG } from 'constants/uTagConstants/paths';

export const IdentityFinishMessageByVideo = ({
    video,
    investmentType,
    userProfileName,
    onHandleFinishIdentity,
    identityMethod,
}) => {
    const TITLE_BY_VIDEO = {
        [VIDEO_CALL]: 'messagesScreen-videoCallFinishTitle',
        [VIDEO_SELFIE]: 'messagesScreen-videoSelfieFinishTitle',
    };

    const MESSAGE_BY_VIDEO = {
        [VIDEO_CALL]: 'messagesScreen-additionalInformation',
        [VIDEO_SELFIE]: 'messagesScreen-additionalInformationVideoSelfie',
    };

    useEffect(() => {
        const identityTypeName = IDENTITY_VIDEOS_RECORD_TAG[identityMethod];
        recordEventStepSuccess(
            investmentType,
            `identidad/${identityTypeName}/finalizado`,
            `confirmacion ${identityTypeName}`
        );
    }, []);

    return (
        <div className="main-container messages-main-container basic-layering">
            <MessagesScreen
                iconClass="icons icons--icon-checked"
                title={<FormattedText value={TITLE_BY_VIDEO[video]} injectedStrings={[userProfileName]} />}
                subtitle={formatText(MESSAGE_BY_VIDEO[video])}
                buttonText={formatText('button-continue')}
                showRoadmapNavigation={true}
                dashTitle={true}
                roadmapNavigationProps={{
                    buttonContinueAction: onHandleFinishIdentity,
                    buttonPrevHidden: true,
                }}
            />
        </div>
    );
};
